import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CampaignIcon from "@mui/icons-material/Campaign";
import FiberNewIcon from "@mui/icons-material/FiberNew";
import LensBlurSharpIcon from "@mui/icons-material/LensBlurSharp";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { Button, Stack, Typography } from "@mui/material";
import { type FC } from "react";
import { useNavigate } from "react-router";

import { ROUTES } from "~/constants/routing";

const BROWSE_ITEMS = [
  { label: "Highlights", icon: LensBlurSharpIcon, href: ROUTES.highlights.path },
  { label: "Trending", icon: ShowChartIcon, href: ROUTES.trending.path },
  { label: "Breaking", icon: CampaignIcon, href: ROUTES.breaking.path },
  { label: "New", icon: FiberNewIcon, href: ROUTES.new.path },
  { label: "Ending Soon", icon: AccessTimeIcon, href: ROUTES.endingSoon.path },
] as const;

interface IBrowseSectionProps {
  onNavigate?: () => void;
}

export const BrowseSection: FC<IBrowseSectionProps> = ({ onNavigate }) => {
  const navigate = useNavigate();

  return (
    <Stack
      sx={{
        gap: 1,
        px: 1.5,
        py: 1.25
      }}>
      <Typography
        variant="caption"
        sx={{
          color: "text.secondary",
          fontWeight: 700,
          textTransform: "uppercase",
          letterSpacing: 0.5
        }}>
        Browse
      </Typography>
      <Stack
        direction="row"
        sx={{
          flexWrap: "wrap",
          gap: 0.75
        }}>
        {BROWSE_ITEMS.map(({ label, icon: Icon, href }) => (
          <Button
            key={label}
            variant="outlined"
            size="small"
            startIcon={<Icon fontSize="small" />}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => {
              navigate(href);
              onNavigate?.();
            }}
            sx={{
              borderRadius: "10px",
              textTransform: "none",
              color: "text.primary",
              borderColor: "divider",
              fontWeight: 500,
              fontSize: "0.8125rem",
              "&:hover": { borderColor: "text.secondary" },
            }}
          >
            {label}
          </Button>
        ))}
      </Stack>
    </Stack>
  );
};
